import { ReportSubscriptionInterval } from "@/constants";
import { useUser } from "@/hooks/useUser";
import { Report } from "@/types/Report";
import { User } from "@/types/User";
import { Widget as WidgetProps } from "@/types/Widget";
import { formatDateForApi } from "@/utils";
import { autoLayout } from "@/views/reports/layout";

import { Widget } from "../widgets/Widget";

type MaybeCompareWidget = WidgetProps & {
  startDate: Date;
  endDate: Date;
  editable: boolean;
  mirrored: boolean;
};
export type WidgetListProps = {
  reportUuid: string;
  templateName: Report["template"];
  interval: ReportSubscriptionInterval;
  widgets: MaybeCompareWidget[];
  onEditWidgetButtonClick: () => void;
  onSaveEditedWidget: () => void;
  setWidgetToEdit: (w: MaybeCompareWidget) => void;
  startDate: string; // or is it a date?
  endDate: string; // or is it a date?
  fetchMentions: () => void;
};

const WidgetList: React.FunctionComponent<WidgetListProps> = ({
  widgets,
  setWidgetToEdit,
  onEditWidgetButtonClick: passedOnEditWidgetButtonClick,
  templateName,
  reportUuid,
  interval,
  onSaveEditedWidget,
  startDate,
  endDate,
  fetchMentions,
}) => {
  const { data } = useUser();
  let is_readonly = (data?.data as User)?.is_readonly;
  if (is_readonly === undefined) {
    is_readonly = true;
  }

  const onEditWidgetButtonClick = (widget: MaybeCompareWidget) => {
    if (!is_readonly) {
      setWidgetToEdit(widget);
      passedOnEditWidgetButtonClick();
    }
  };

  return (
    <div className="grid grid-cols-12">
      {(autoLayout(templateName, widgets) as MaybeCompareWidget[]).map(
        (widget, i) => (
          // TODO: Type Widget properly as well
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore-next-line
          <Widget
            {...widget}
            reportUuid={reportUuid}
            reportTemplate={templateName}
            interval={interval}
            key={`${widget?.uuid || i}-${widget.mirrored ? "mirrored" : ""}`}
            editable={widget.editable === false ? false : true}
            onEditWidgetButtonClick={() => onEditWidgetButtonClick(widget)}
            onSaveEditedWidget={onSaveEditedWidget}
            startDate={formatDateForApi(widget.startDate || startDate)}
            endDate={formatDateForApi(widget.endDate || endDate || new Date())}
            fetchMentions={fetchMentions}
          />
        )
      )}
    </div>
  );
};
export default WidgetList;
